<div class="tml-tpl-ctrl-wrap">
    <!--Job Title-->
    <div class="tam-contact-control">
        <label>Job Title</label>
        <div>
            <kendo-dropdownlist [style.width.px]="childConfig.css.leftWidth" [disabled]="true">
            </kendo-dropdownlist>
        </div>
    </div>
    <!--Compnay-->
    <div class="tam-contact-control">
        <label>Company</label>
        <div>
            <kendo-dropdownlist [style.width.px]="childConfig.css.rightWidth" [disabled]="true">
            </kendo-dropdownlist>
        </div>
    </div>
</div>
<div class="tml-tpl-ctrl-wrap">
    <!--useless-->
    <div class="tam-contact-control" [style.visibility]="'hidden'">
        <input class="tam-input" [style.width.px]="childConfig.css.leftWidth" [style.height.px]="childConfig.heigh" />
    </div>
    <!--start end year-->
    <div class="tam-contact-control">
        <label>Start Year</label>
        <div>
            <kendo-dropdownlist [style.width.px]="childConfig.css.rightWidthYear" [disabled]="true">
            </kendo-dropdownlist>
        </div>
    </div>
    <div class="tam-contact-control">
        <label>End Year<span style="color:red;">&nbsp;*</span></label>
        <div>
            <kendo-dropdownlist [style.width.px]="childConfig.css.rightWidthYear" [disabled]="true">
            </kendo-dropdownlist>
        </div>
    </div>
</div>